import queryString from 'query-string'
import React, { useEffect, useRef } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { useUpdateOnboardingChecklistMutation } from '@/hooks/useUpdateOnboardingChecklistMutation'
import { EXTERNAL_LINKS } from '@/lib/constants'
import {
  ONBOARDING_CHECKLIST_STEP,
  selectOnboardingChecklist,
} from '@/redux/slices/onboardingChecklist'
import {
  hideVideoModal,
  selectVideoModalVideoUrl,
} from '@/redux/slices/videoModal'

const VideoModal: React.FC = () => {
  const videoUrl = useAppSelector(selectVideoModalVideoUrl)
  const onboardingChecklist = useAppSelector(selectOnboardingChecklist)
  const dispatch = useAppDispatch()
  const onboardingChecklistMutation = useUpdateOnboardingChecklistMutation()
  const onboardingChecklistMutationRef = useRef(onboardingChecklistMutation)

  useEffect(() => {
    const shouldMarkExploreAsCompleted =
      onboardingChecklist &&
      onboardingChecklist.exploreCompass === false &&
      videoUrl === EXTERNAL_LINKS.vimeo.compass

    if (shouldMarkExploreAsCompleted) {
      onboardingChecklistMutationRef.current.mutate({
        checklistId: onboardingChecklist.id,
        request: { [ONBOARDING_CHECKLIST_STEP.exploreCompass]: true },
      })
    }
  }, [onboardingChecklist, videoUrl])

  if (!videoUrl) {
    return null
  }

  const vimeoEmbedParams = {
    autoplay: 1,
    transparent: 1,
    autopause: 0,
  }

  const vimeoEmbedUrl = `${videoUrl}&${queryString.stringify(vimeoEmbedParams)}`

  return (
    <Dialog open={!!videoUrl} onHide={() => dispatch(hideVideoModal())}>
      <DialogContent size="xl" showCloseButton={false}>
        <DialogBody>
          <iframe
            title="Vimeo video player"
            src={vimeoEmbedUrl}
            width="1000"
            height="560"
            frameBorder="0"
            style={{ backgroundColor: 'black', width: '100%' }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </DialogBody>

        <DialogFooter>
          <Button
            variant="outline-secondary"
            onClick={() => dispatch(hideVideoModal())}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default VideoModal
